import React from 'react';

interface FiltersState {
  type: string;
  category: string;
  owner: string;
  status: string;
  startDate: string;
  endDate: string;
}

interface TransactionFiltersProps {
  filters: FiltersState;
  onFilterChange: (filters: FiltersState) => void;
}

export const TransactionFilters: React.FC<TransactionFiltersProps> = ({
  filters,
  onFilterChange,
}) => {
  const resetFilters = () => {
    onFilterChange({
      type: '',
      category: '',
      owner: '',
      status: '',
      startDate: '',
      endDate: '',
    });
  };

  return (
    <div className="bg-[#111]/80 backdrop-blur-xl rounded-[20px] p-6 border border-white/[0.08] space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Tipo */}
        <div>
          <label className="block text-sm text-white/60 mb-2">Tipo</label>
          <select
            value={filters.type || ''}
            onChange={(e) => onFilterChange({ ...filters, type: e.target.value || undefined })}
            className="w-full bg-[#222] border border-white/10 rounded-lg p-2 text-sm"
          >
            <option value="">Todos</option>
            <option value="Receita">Receita</option>
            <option value="Despesas">Despesas</option>
            <option value="Salário">Salário</option>
          </select>
        </div>

        {/* Proprietário */}
        <div>
          <label className="block text-sm text-white/60 mb-2">Proprietário</label>
          <select
            value={filters.owner || ''}
            onChange={(e) => onFilterChange({ ...filters, owner: e.target.value || undefined })}
            className="w-full bg-[#222] border border-white/10 rounded-lg p-2 text-sm"
          >
            <option value="">Todos</option>
            <option value="Luiz">Luiz</option>
            <option value="Empresa">Empresa</option>
          </select>
        </div>

        {/* Status */}
        <div>
          <label className="block text-sm text-white/60 mb-2">Status</label>
          <select
            value={filters.status || ''}
            onChange={(e) => onFilterChange({ ...filters, status: e.target.value || undefined })}
            className="w-full bg-[#222] border border-white/10 rounded-lg p-2 text-sm"
          >
            <option value="">Todos</option>
            <option value="Done">Concluído</option>
            <option value="Not started">Não iniciado</option>
            <option value="In progress">Em andamento</option>
          </select>
        </div>

        {/* Categoria */}
        <div>
          <label className="block text-sm text-white/60 mb-2">Categoria</label>
          <input
            type="text"
            value={filters.category || ''}
            onChange={(e) => onFilterChange({ ...filters, category: e.target.value || undefined })}
            placeholder="Filtrar por categoria"
            className="w-full bg-[#222] border border-white/10 rounded-lg p-2 text-sm"
          />
        </div>
      </div>

      {/* Data */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm text-white/60 mb-2">Data Inicial</label>
          <input
            type="date"
            value={filters.startDate || ''}
            onChange={(e) => onFilterChange({ ...filters, startDate: e.target.value || undefined })}
            className="w-full bg-[#222] border border-white/10 rounded-lg p-2 text-sm [color-scheme:dark]"
          />
        </div>
        <div>
          <label className="block text-sm text-white/60 mb-2">Data Final</label>
          <input
            type="date"
            value={filters.endDate || ''}
            onChange={(e) => onFilterChange({ ...filters, endDate: e.target.value || undefined })}
            className="w-full bg-[#222] border border-white/10 rounded-lg p-2 text-sm [color-scheme:dark]"
          />
        </div>
      </div>

      {/* Botão Limpar */}
      <div className="flex justify-end">
        <button
          onClick={() => onFilterChange({})}
          className="px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors text-sm"
        >
          Limpar Filtros
        </button>
      </div>
    </div>
  );
};
